import { useState, useEffect } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { SharedLink } from '@/types';

interface UseSharedLinkResult {
  link: SharedLink | null;
  error: string | null;
  isValid: boolean;
  isLoading: boolean;
}

export function useSharedLink(token: string | undefined, type: 'add' | 'info' | 'view'): UseSharedLinkResult {
  const [result, setResult] = useState<UseSharedLinkResult>({
    link: null,
    error: null,
    isValid: false,
    isLoading: true
  });

  const getSharedLink = useFamilyStore(state => state.getSharedLink);

  useEffect(() => {
    if (!token) {
      setResult({
        link: null,
        error: 'رابط غير صالح',
        isValid: false,
        isLoading: false
      });
      return;
    }

    try {
      const link = getSharedLink(token);
      
      if (!link) {
        setResult({
          link: null,
          error: 'هذا الرابط غير موجود أو منتهي الصلاحية',
          isValid: false,
          isLoading: false
        });
        return;
      }

      if (!link.isActive) {
        setResult({
          link: null,
          error: 'هذا الرابط غير نشط',
          isValid: false,
          isLoading: false
        });
        return;
      }

      if (link.type !== type) {
        setResult({
          link: null,
          error: 'نوع الرابط غير صحيح',
          isValid: false,
          isLoading: false
        });
        return;
      }

      setResult({
        link,
        error: null,
        isValid: true,
        isLoading: false
      });
    } catch (error) {
      setResult({
        link: null,
        error: 'حدث خطأ أثناء التحقق من الرابط',
        isValid: false,
        isLoading: false
      });
    }
  }, [token, type, getSharedLink]);

  return result;
}